export const RIDE_CANCEL_TYPES = {
  singleRide: 'single_ride',
  allFutureRides: 'all_future_rides',
  allFutureRidesFromDate: 'all_future_rides_from_date',
};
